// import React from "react";
// import { Field, ErrorMessage } from "formik";
// import { FormGroup, FormLabel, Row } from "react-bootstrap";

// const TextAreaInput = ({ label, name, placeholder, rows = 4, ...rest }) => {
//   return (
//     <>
//       <Row>
//         <FormGroup>
//           <FormLabel className="col-form-label text-dark" htmlFor={name}>
//             {label}
//           </FormLabel>
//           <div>
//             <Field
//               as="textarea"
//               className="form-control"
//               id={name}
//               name={name}
//               placeholder={placeholder}
//               rows={rows}
//               {...rest}
//             />
//             <ErrorMessage name={name} component="div" className="error-message text-danger" />
//           </div>
//         </FormGroup>
//       </Row>
//     </>
//   );
// };

// export default TextAreaInput;


import React from "react";
import { Field, ErrorMessage } from "formik";
import { FormGroup, FormLabel, Row } from "react-bootstrap";

const TextAreaInput = ({ label, isRequired, name, placeholder, rows = 4, ...rest }) => {
  return (
    <>
      <Row>
        <FormGroup>
          <FormLabel className="col-form-label text-dark fw-bold" htmlFor={name}>
            {label}:{isRequired && <span className="text-danger">*</span>}
          </FormLabel>
          <div>
            <Field
              as="textarea"
              className="form-control"
              id={name}
              name={name}
              placeholder={placeholder}
              rows={rows}
              {...rest}
            />
            <ErrorMessage name={name} component="div" className="error-message text-danger" />
          </div>
        </FormGroup>
      </Row>
    </>
  );
};

export default TextAreaInput;
